// extracted by mini-css-extract-plugin
export var cardHeader = "_k8-0";
export var reorderHandle = "_k8-3";
export var titleArea = "_k8-1";
export var titleAreaWithHandle = "_k8-2";